// import Cookies from 'js-cookie'
// import Settings from '../settings'
//
// export function getToken() {
//   return Cookies.get(Settings.cookieKey)
// }
//
// export function setToken(token) {
//   return Cookies.set(Settings.cookieKey, token)
// }
//
// export function removeToken() {
//   return Cookies.remove(Settings.cookieKey)
// }

import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}
